import React, { useState } from 'react';
import { showError } from 'utils';
import EditAction from './EditAction';

const EditActionForTable = (props) => {
  const { onClick } = props;
  const [loading, setLoading] = useState<boolean>(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await onClick();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <EditAction loading={loading} onClick={handleClick} />
    </>
  );
};

export default EditActionForTable;
